<template>
  <b-modal
    :active.sync="show"
    :can-cancel="['escape', 'outside', 'x']"
    :width="500"
    @cancel="handleCancel"
  >
    <div v-if="currentNotification">
      <div class="custom-notification-modal">
        <div class="modal-content">
          <span class="modal-icon">
            <b-icon icon="bell" size="is-large" class="mr-3" />
          </span>
          <span class="modal-message" v-html="currentNotification.message"></span>
        </div>
        <div v-if="currentNotification.action" class="modal-action-btn-wrapper">
          <a
            :href="currentNotification.action"
            target="_blank"
            rel="noopener noreferrer"
            class="modal-action-btn"
            @click.prevent="onActionClick"
          >
            {{ currentNotification.action_name || 'View Details' }}
          </a>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import request from '../request';

export default {
  name: 'UserNotificationModal',
  props: {
    notifications: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      currentIndex: 0,
    };
  },
  computed: {
    currentNotification() {
      return this.notifications[this.currentIndex] || null;
    },
  },
  methods: {
    async handleCancel() {
      if (!this.currentNotification) return;
      try {
        await request.post(`/user/notifications/${this.currentNotification.id}/dismiss`);
        this.$emit('dismiss', this.currentNotification.id);
        this.currentIndex++;
        if (!this.currentNotification) {
          this.show = false;
        }
      } catch (e) {
        this.$buefy.toast.open({
          message: 'Failed to dismiss notification',
          type: 'is-danger',
        });
      }
    },
    async onActionClick() {
      const url = this.currentNotification && this.currentNotification.action;
      await this.handleCancel();
      if (url) {
        window.location.assign(url);
      }
    },
  },
};
</script>

<style scoped>
.custom-notification-modal {
  background: #7957d5;
  color: #fff;
  border-radius: 1rem;
  box-shadow:
    0 4px 24px rgba(0, 0, 0, 0.12),
    0 1.5px 4px rgba(0, 0, 0, 0.1);
  padding: 2rem 1.5rem 1.5rem 1.5rem;
  margin: 0.5rem 0;
  animation: fadeIn 0.5s;
  position: relative;
}
.modal-content {
  display: flex;
  align-items: center;
}
.modal-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  font-size: 2.2rem;
}
.modal-message {
  flex: 1;
  font-size: 1.15rem;
  margin-left: 0.5rem;
  margin-right: 1.5rem;
  word-break: break-word;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
:deep(.modal-close.is-large) {
  font-size: 2.5rem !important;
  color: #fff !important;
  background: #7957d5 !important;
  opacity: 1 !important;
  right: 1.25rem !important;
  top: 1.25rem !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  z-index: 10;
  transition:
    background 0.2s,
    color 0.2s;
}
:deep(.modal-close.is-large:hover) {
  background: #fff !important;
  color: #7957d5 !important;
}
.modal-action-btn-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
}
.modal-action-btn {
  background: #fff;
  color: #7957d5;
  border: none;
  border-radius: 4px;
  padding: 0.35rem 1rem;
  font-weight: 600;
  font-size: 0.98rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  text-decoration: none;
  transition:
    background 0.2s,
    color 0.2s;
}
.modal-action-btn:hover {
  background: #7957d5;
  color: #fff;
}
</style>
